export default {
  'Choose File': 'Выбрать файл',
  'Please paste a URL': 'Введите URL-ссылку на видео',
  'Loading': 'Загрузка',
  'Analyzing': 'Загружается',
  'Try a sample': 'Попробуйте пример',
  'Sorry, error occurs when analyzing the URL.': 'Извините, произошла ошибка при разборе URL-адресов.',
  'Upload a photo': 'Загрузить фотографию',
  "Drag and drop files to the upload box.": 'Перетаскивать файлы в окно загрузки.',
  'Please select the proper position with portrait.': 'Пожалуйста, выберите правильное положение с портретом.',
  'downloading': 'скачивание',
}